import React, { useContext, useEffect } from "react";

// Third-party
import PropTypes from "prop-types";

// Context
import { AuthContext } from "AuthProvider";

// Components
import ErrorBoundary from "./ErrorBoundary";

// Other
import { PATHFINDER_VERSION } from "assets/global";

/**
 * Wrapper component that provides user context and app version to ErrorBoundary
 * This is necessary because ErrorBoundary is a class component and cannot use hooks
 */
function ErrorBoundaryWrapper({ children }) {
  const authContext = useContext(AuthContext);
  const version = PATHFINDER_VERSION;

  // Update global user variable for error handlers
  useEffect(() => {
    if (authContext?.userName) {
      window.__PATHFINDER_CURRENT_USER__ = authContext.userName;
    } else {
      window.__PATHFINDER_CURRENT_USER__ = null;
    }
  }, [authContext?.userName]);

  return (
    <ErrorBoundary userName={authContext?.userName} version={version}>
      {children}
    </ErrorBoundary>
  );
}

ErrorBoundaryWrapper.propTypes = {
  children: PropTypes.node.isRequired
};

export default ErrorBoundaryWrapper;
